import React from 'react'

// eslint-disable-next-line
export default ({title, clsName='section-title'}) => 
	<div className={clsName}>
		<h4>{title}</h4>
		<div />
	</div>